import Vue from 'vue';
import VueI18n from 'vue-i18n';
import languages from './lang/languages';

Vue.use(VueI18n);

const messages = {
    es: require('./lang/app/es.json'),
    en: require('./lang/app/en.json'),
    pt: require('./lang/app/pt.json'),
    tr: require('./lang/app/tr.json'),
    //de: require('./lang/app/de.json'),
};

const dateTimeFormats = {
    es: languages.find(val => val.code === 'es').dateTimeFormat,
    en: languages.find(val => val.code === 'en').dateTimeFormat,
    pt: languages.find(val => val.code === 'pt').dateTimeFormat,
    tr: languages.find(val => val.code === 'tr').dateTimeFormat,
    //de: languages.find(val => val.code === 'de').dateTimeFormat
};

const numberFormats = {
    es: languages.find(val => val.code === 'es').numberFormat,
    en: languages.find(val => val.code === 'en').numberFormat,
    pt: languages.find(val => val.code === 'pt').numberFormat,
    tr: languages.find(val => val.code === 'tr').numberFormat,
    //de: languages.find(val => val.code === 'de').numberFormat
};

const i18n = new VueI18n({
    locale: languages[0].code,
    messages,
    dateTimeFormats,
    numberFormats,
});

export default i18n;